// extracted by mini-css-extract-plugin
module.exports = {"container":"BottomPageControlsWrapper_container__tZTPZ"};